module.exports = __webpack_public_path__ + "img/black-tassel.fab5cfcd.webp";